import { render, staticRenderFns } from "./ExtensionDetail.vue?vue&type=template&id=5aa352ae&scoped=true&"
import script from "./ExtensionDetail.vue?vue&type=script&lang=js&"
export * from "./ExtensionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionDetail.vue?vue&type=style&index=0&id=5aa352ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa352ae",
  null
  
)

export default component.exports